/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Header, Segment } from '@mairistem/composants';

import PiedInsee from './PiedInsee';
import type { VueInsee } from './types';

interface PageInseeProps {
  vue: VueInsee;
  'data-testid': string;
}

/** Écran INSEE en page, depuis le menu « Transmission INSEE » (cadre des listes PACS) */
const PageInsee = ({ vue, 'data-testid': testId }: PageInseeProps) => (
  <Segment basic secondary style={{ margin: 0, height: '100%' }}>
    <Segment
      raised
      data-testid={testId}
      style={{
        height: '100%',
        overflow: 'hidden',
        borderRadius: '16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '1em',
      }}
    >
      {/* Même titre que les listes PACS (ListeHeader de @mairistem/liste) */}
      <Header style={{ margin: 0 }}>{vue.titre}</Header>
      <div style={{ flex: 1, minHeight: 0 }}>{vue.corps}</div>
      {(vue.message || vue.boutons) && (
        <PiedInsee message={vue.message}>{vue.boutons}</PiedInsee>
      )}
    </Segment>
    {vue.dialogues}
  </Segment>
);

export default PageInsee;
